import React from 'react';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Slider } from '../ui/slider';
import { Search, X } from 'lucide-react';

const categories = [
  { value: '', label: 'All Categories' },
  { value: 'adventure', label: 'Adventure Tours' },
  { value: 'marine', label: 'Marine Tours' },
  { value: 'food', label: 'Food Tours' },
  { value: 'night', label: 'Night Tours' },
];

export const TourFilters = ({ filters, setFilters, onClear }) => {
  const handleCategoryChange = (category) => {
    setFilters({ ...filters, category });
  };

  const handlePriceChange = (value) => {
    setFilters({ ...filters, maxPrice: value[0] });
  };

  const handleSearchChange = (e) => {
    setFilters({ ...filters, search: e.target.value });
  };

  const hasActiveFilters = filters.category || filters.maxPrice < 200 || filters.search;

  return (
    <div className="bg-white rounded-2xl border border-border p-6 space-y-6" data-testid="tour-filters">
      {/* Search */}
      <div>
        <Label className="text-sm font-medium mb-2 block">Search</Label>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search tours..."
            value={filters.search}
            onChange={handleSearchChange}
            className="pl-10 rounded-lg"
            data-testid="search-input"
          />
        </div>
      </div>

      {/* Category */}
      <div>
        <Label className="text-sm font-medium mb-3 block">Category</Label>
        <div className="space-y-2">
          {categories.map((cat) => (
            <button
              key={cat.value}
              onClick={() => handleCategoryChange(cat.value)}
              className={`w-full text-left px-4 py-2 rounded-lg text-sm transition-colors ${
                filters.category === cat.value
                  ? 'bg-primary text-primary-foreground'
                  : 'hover:bg-muted'
              }`}
              data-testid={`category-filter-${cat.value || 'all'}`}
            >
              {cat.label}
            </button>
          ))}
        </div>
      </div>

      {/* Price Range */}
      <div>
        <Label className="text-sm font-medium mb-3 block">
          Max Price: ${filters.maxPrice}
        </Label>
        <Slider
          value={[filters.maxPrice]}
          onValueChange={handlePriceChange}
          max={200}
          min={0}
          step={10}
          className="mt-2"
          data-testid="price-slider"
        />
        <div className="flex justify-between text-xs text-muted-foreground mt-2">
          <span>$0</span>
          <span>$200</span>
        </div>
      </div>

      {/* Clear Filters */}
      {hasActiveFilters && (
        <Button
          variant="outline"
          onClick={onClear}
          className="w-full gap-2"
          data-testid="clear-filters-btn"
        >
          <X className="h-4 w-4" />
          Clear Filters
        </Button>
      )}
    </div>
  );
};
